module.exports = "<div id=\"mobie-dtcr\">\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\">Role Update</h4>\n    </div>\n    <div class=\"modal-body\">\n      <p> You will access the app features as the new role permits</p>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"button\" (click)=\"closeModal()\" class=\"save-btn btn btn-default\">Okay</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-role-degrade/user-role-degrade.component.html
// module id = ./src/app/user-role-degrade/user-role-degrade.component.html
// module chunks = main